module.exports = __webpack_public_path__ + "static/img/u70073.6e2dda16.png";